var _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyphen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 2,
    viewBox: "0 0 15 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:2px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 13,
    transform: "translate(1 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyphen);
export default __webpack_public_path__ + "static/media/hyphen.b0fd47c5e94db30ffdbc0330966d237e.svg";
export { ForwardRef as ReactComponent };